import { IMissingInfo } from 'src/interfaces/user-mobile/missing.interface';
import MissingPersonPopupBox from './MissingPersonPopupBox';

function MissingPersonPopup({
  missingPersonList,
}: {
  missingPersonList: IMissingInfo[];
}) {
  return (
    <>
      {missingPersonList.map((info: IMissingInfo, i: number) => {
        return (
          <MissingPersonPopupBox
            info={info}
            i={i}
            total={missingPersonList?.length}
          />
        );
      })}
    </>
  );
}

export default MissingPersonPopup;
